$(document).ready(function(){
    function onWindowResize() {
      if ($(window).width() < 768) {
          $('.products-grid-alt').slick({
              waitForAnimate: false,
              speed: 200,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: true,
              arrows: true,
              nextArrow: '<button type="button" class="slick-next"><img class="a-right1 tr control-c next slick-next slick-arrow" src="https://cdn.shopify.com/s/files/1/0599/2919/8777/files/dfd-removebg-preview.webp?v=1663625204" style=""></button>',
              prevArrow: '<button type="button" class="slick-prev"><img class="a-left1 control-c prev slick-prev slick-arrow" src="https://cdn.shopify.com/s/files/1/0599/2919/8777/files/pre-removebg-preview.webp?v=1663625204" style=""></button>',
          });
  
          var announcement_bar = $('[data-announcement-bar]');
          var announcement_item = announcement_bar.find('.announcement-bar__message');
  
          if(announcement_item.length > 1){
              if(!announcement_bar.hasClass('slick-initialized')){
                  announcement_bar.slick({
                      waitForAnimate: false,
                      speed: 200,
                      infinite: true,
                      vertical: true,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      dots: false,
                      arrows: announcement_bar.data('arrows'),
                      autoplay: true,
                      autoplaySpeed: 3000,
                      nextArrow: '<button type="button" class="slick-next"><svg viewBox="0 0 478.448 478.448" class="icon icon-chevron-right" id="icon-chevron-right"><g><g><polygon points="131.659,0 100.494,32.035 313.804,239.232 100.494,446.373 131.65,478.448 377.954,239.232"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>',
                      prevArrow: '<button type="button" class="slick-prev"><svg viewBox="0 0 370.814 370.814" class="icon icon-chevron-left" id="icon-chevron-left"><g><g><polygon points="292.92,24.848 268.781,0 77.895,185.401 268.781,370.814 292.92,345.961 127.638,185.401"></polygon></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>',
                  });
              }
          }

         setTimeout(function() {
            $('#shopify-section-product-recommendations .products-carousel').slick({
                waitForAnimate: false,
                speed: 200,
                dots: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                adaptiveHeight: true,
                arrows: false,
                // arrows: true // Hide arrows for mobile
            });
         }, 1000)
       }
    }

    // Add event listener for window resize
    $(window).resize(onWindowResize);

    // Optional: Call the function initially to set the initial size
    onWindowResize();

  function initializeSlickSlider() {
    if ($(window).width() < 768 && $('.featured-collection-list').length >= 1) {
      // Check if the slider is not already initialized
      if (!$('.featured-collection-list').hasClass('slick-initialized')) {
        $('.featured-collection-list').slick({
          waitForAnimate: false,
          speed: 200,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          arrows: true,
          prevArrow:'<button type="button" class="slick-prev"><img class="a-left2 tr control-c prev slick-prev" src="https://cdn.shopify.com/s/files/1/0599/2919/8777/files/pre-removebg-preview.webp?v=1663625204"></button>',
          nextArrow:'<button type="button" class="slick-next"><img class="a-right2 tr control-c next slick-next" src="https://cdn.shopify.com/s/files/1/0599/2919/8777/files/dfd-removebg-preview.webp?v=1663625204"></button>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
          ]
        });
      }
    } else {
      // If the window is resized and exceeds the breakpoint, destroy the slick slider
      if ($('.featured-collection-list').hasClass('slick-initialized')) {
        $('.featured-collection-list').slick('unslick');
      }
    }
  }

  // Initialize the slider on page load
  initializeSlickSlider();

  // Reinitialize the slider on window resize
  $(window).on('resize', function() {
    initializeSlickSlider();
  });

})